var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-category-add-modal",
        title: "Add New Category",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Category Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("name") },
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("name") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.name) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Category Type" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.categoryTypes,
                  state: _vm.fieldValid("category_type"),
                },
                model: {
                  value: _vm.formData.category_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "category_type", $$v)
                  },
                  expression: "formData.category_type",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("category_type") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.category_type) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Bulk or Packaged for Retail" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.bulkOrPackagedOptions,
                  state: _vm.fieldValid("bulk_or_packaged"),
                },
                model: {
                  value: _vm.formData.bulk_or_packaged,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bulk_or_packaged", $$v)
                  },
                  expression: "formData.bulk_or_packaged",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("bulk_or_packaged") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.bulk_or_packaged) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBulk
            ? _c(
                "b-form-group",
                { attrs: { label: "Bulk Units of Measure" } },
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: { state: _vm.fieldValid("bulk_unit_types") },
                      model: {
                        value: _vm.formData.bulk_unit_types,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "bulk_unit_types", $$v)
                        },
                        expression: "formData.bulk_unit_types",
                      },
                    },
                    _vm._l(_vm.unitTypesOptions, function (option, key) {
                      return _c(
                        "b-form-checkbox",
                        { key: key, attrs: { value: option.value } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(option.text) + "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.fieldValid("bulk_unit_types") } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formValidation.bulk_unit_types) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPackaged
            ? _c(
                "b-form-group",
                { attrs: { label: "Packaged Units of Measure" } },
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: { state: _vm.fieldValid("packaged_unit_types") },
                      model: {
                        value: _vm.formData.packaged_unit_types,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "packaged_unit_types", $$v)
                        },
                        expression: "formData.packaged_unit_types",
                      },
                    },
                    _vm._l(_vm.unitTypesOptions, function (option, key) {
                      return _c(
                        "b-form-checkbox",
                        { key: key, attrs: { value: option.value } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(option.text) + "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.fieldValid("packaged_unit_types") } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formValidation.packaged_unit_types) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "THC/CBD Units" } },
            [
              _c(
                "b-form-checkbox-group",
                {
                  attrs: { state: _vm.fieldValid("thc_cbd_options") },
                  model: {
                    value: _vm.formData.thc_cbd_options,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "thc_cbd_options", $$v)
                    },
                    expression: "formData.thc_cbd_options",
                  },
                },
                _vm._l(_vm.thcCbdOptions, function (option, key) {
                  return _c(
                    "b-form-checkbox",
                    { key: key, attrs: { value: option.value } },
                    [
                      _vm._v(
                        "\n          " + _vm._s(option.text) + "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("thc_cbd_options") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.thc_cbd_options) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }